module.exports = __webpack_public_path__ + "static/media/utanverdlaeri_small.97ec17fb.png";